<!-- 字典数据-->
<template>
  <div>
    <x-dictionaryData></x-dictionaryData>
  </div>
</template>

<script>
import { dictionaryData } from 'ant-design-vue-admin-x';
export default {
  name: 'dictionaryData',
  components: { XDictionaryData: dictionaryData }
};
</script>
